<template>
  <li class="row">
    <div class="title">
      {{ configuration.CatalogCarName }}
      <div>
        <br />
        <small>{{ configuration.OrderCodeIDS }}</small
        ><br />
        <template v-if="!configuration.IsCC2">
          <small class="configuration-id">{{ configuration.Id }}</small
          ><br />
        </template>
        <!-- PrecalculativeResultGuid is not an id: the margin is spliced into it server-side -->
        <template v-if="quote && canViewVcr">
          <small>{{ quote.PrecalculativeResultGuid }}</small
          ><br />
        </template>
        <emission-and-consumption
          :configuration="configuration"
          @update-calculate-bpm="updateCalculateBpm"
        />
      </div>
    </div>
    <div v-if="showExclPrice" class="price price-excl">
      {{ i18n.n(configuration.NetCatalogPrice.Excl, 'currency') }}
    </div>
    <div v-if="showInclPrice" class="price price-incl">
      {{ i18n.n(configuration.NetCatalogPrice.Incl, 'currency') }}
    </div>
  </li>
</template>

<script>
import EmissionAndConsumption from '@/components/generic/presentational/molecules/emissionAndConsumption/EmissionAndConsumption.vue'
import StoreConnector from '@/helpers/StoreConnector'
import { mapGetters } from 'vuex'

export default {
  components: {
    EmissionAndConsumption,
  },
  props: {
    configuration: {
      type: Object,
      default: null,
    },
  },
  emits: ['updateCalculateBpm'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      quote: null,
    }
  },
  computed: {
    ...mapGetters({
      showInclPrice: 'quote/isPriceShowIncl',
      showExclPrice: 'quote/isPriceShowExcl',
      canViewVcr: 'user/canViewVcr',
    }),
  },
  created() {
    StoreConnector.get('quote/get', (data) => {
      this.quote = data
    })
  },
  methods: {
    updateCalculateBpm(calculateBpm) {
      this.$emit('updateCalculateBpm', calculateBpm)
    },
  },
}
</script>

<style lang="scss" scoped>
.configuration-id {
  word-wrap: break-word;
}
.title {
  overflow: auto;
}
</style>
